export default __webpack_public_path__ + "static/media/icon-answer-briefcase.cd8cc970.svg";